import { Injectable, OnInit } from "@angular/core";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})

export class HospitalService implements OnInit {

    private currentUser: any;

    private hospital = new BehaviorSubject(null);
    currentHospital = this.hospital.asObservable();

    private firebaseHospitalCollection: AngularFirestoreCollection;

    constructor(
        private angularFirestore: AngularFirestore) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

        const hospitalUser = JSON.parse(localStorage.getItem('hospitalUser'));
        if (hospitalUser) {
            this.hospital.next(hospitalUser);
        }
    }

    ngOnInit() {

    }

    async getHospitalById(id: string) {
        try {
            let hospital = null;

            if (this.firebaseHospitalCollection == null) {
                this.firebaseHospitalCollection = this.angularFirestore.collection('OrgLocation');
            }

            // Get the first document where the id matches the user_id
            // await this.firebaseHospitalCollection.ref
            //     .doc(id)
            //     .get()
            //     .then(querySnapshot => {
            //         const docData = {
            //             id: querySnapshot.id,
            //             ...querySnapshot.data()
            //         }
            //         hospital = docData;
            //     }).catch(err => console.log("getHospitalById query 1 error: " + err));
            await this.firebaseHospitalCollection.ref
                .where('user_id', '==', id)
                .limit(1)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const docData = {
                            id: doc.id,
                            ...doc.data()
                        }
                        hospital = docData;
                    });
                }).catch(err => console.log("getHospitalById query 1 error: " + err));

            localStorage.setItem('hospitalUser', JSON.stringify(hospital));
            this.hospital.next(hospital);
            return hospital;
        } catch (error) {
            console.log('getHospitalById(): ' + JSON.stringify(error));
        }
    }


    async getHospitalByUserID() {
        try {
            let hospital = null;

            if (this.firebaseHospitalCollection == null) {
                this.firebaseHospitalCollection = this.angularFirestore.collection('OrgLocation');
            }

            await this.firebaseHospitalCollection.ref
                .doc(this.currentUser.id)
                .get()
                .then(querySnapshot => {
                    const docData = {
                        id: querySnapshot.id,
                        ...querySnapshot.data()
                    }
                    hospital = docData;
                }).catch(err => console.log("getHospitalByUserID query 1 error: " + err));

            localStorage.setItem('hospitalUser', JSON.stringify(hospital));
            this.hospital.next(hospital);
            return hospital;
        } catch (error) {
            console.log('getHospitalByUserID(): ' + JSON.stringify(error));
        }
    }

    async saveHospitalProfile(hospital: any) {
        try {
            if (this.firebaseHospitalCollection == null) {
                this.firebaseHospitalCollection = this.angularFirestore.collection('OrgLocation');
            }

            await this.firebaseHospitalCollection.ref
                .doc(hospital.id)
                .update({
                    location_name: hospital.location_name,
                    contact_name: hospital.contact_name,
                    email: hospital.email,
                    phone: hospital.phone ? hospital.phone : '',
                    address_1: hospital.address_1 ? hospital.address_1 : '',
                    address_2: hospital.address_2 ? hospital.address_2 : '',
                    city: hospital.city ? hospital.city : '',
                    zipcode: hospital.zipcode ? hospital.zipcode : '',
                    state: hospital.state ? hospital.state : '',
                    country: hospital.country,
                    timezone: hospital.timezone,

                })
                .catch((error) => {
                    console.error("Error updating saveHospitalProfile: ", error);
                    return false;
                });

            // update current hospital, get current hospital and update each key
            let updatedHospital = this.hospital.getValue();
            updatedHospital.location_name = hospital.location_name;
            updatedHospital.contact_name = hospital.contact_name;
            updatedHospital.email = hospital.email;
            updatedHospital.phone = hospital.phone;
            updatedHospital.address_1 = hospital.address_1;
            updatedHospital.address_2 = hospital.address_2;
            updatedHospital.city = hospital.city;
            updatedHospital.zipcode = hospital.zipcode;
            updatedHospital.state = hospital.state;
            updatedHospital.country = hospital.country;
            updatedHospital.timezone = hospital.timezone;

            localStorage.setItem('hospitalUser', JSON.stringify(updatedHospital));
            this.hospital.next(updatedHospital);

            return true;
        } catch (error) {
            console.log('saveHospitalProfile(): ' + JSON.stringify(error));
        }
    }

    setUser(currentUser: any) {
        this.currentUser = currentUser;
        this.getHospitalByUserID();
    }

}